export const setUnauthorizedUserRedirectPage = (type: string) => localStorage.setItem('ej_unauthorized_redirect', type);

export const getUnauthorizedUserRedirectPage = (): string => localStorage.getItem('ej_unauthorized_redirect') || '';

export const resetUnauthorizedUserRedirectPage = () => localStorage.removeItem('ej_unauthorized_redirect');
